import { CheckCircle2, Circle, Loader2, XCircle } from 'lucide-react'

export type AnalysisWorkflowStepId = string

export type AnalysisWorkflowStepState = 'pending' | 'active' | 'completed' | 'failed'

export type AnalysisWorkflowStep = {
  id: AnalysisWorkflowStepId
  label: string
  state: AnalysisWorkflowStepState
}

type AnalysisWorkflowProps = {
  steps: AnalysisWorkflowStep[]
  transparency: string
}

function StepIcon({ state }: { state: AnalysisWorkflowStepState }) {
  if (state === 'completed') {
    return <CheckCircle2 aria-hidden="true"/>
  }

  if (state === 'failed') {
    return <XCircle aria-hidden="true"/>
  }

  if (state === 'active') {
    return <Loader2 aria-hidden="true"/>
  }

  return <Circle aria-hidden="true"/>
}

export function AnalysisWorkflow({ steps, transparency }: AnalysisWorkflowProps) {
  const activeStep = steps.find((step) => step.state === 'active' || step.state === 'failed')

  return <div className="ts-analysis-workflow" aria-label="Analysis workflow">
    <div className="ts-analysis-workflow-head">
      <span className="ts-demo-badge">SIMULATED ANALYSIS</span>
      <p>{transparency}</p>
      <div role="status" aria-live="polite">
        {activeStep ? `${activeStep.label}: ${activeStep.state}` : 'Analysis workflow ready'}
      </div>
    </div>
    <ol>
      {steps.map((step) => <li className={step.state} key={step.id}>
        <span><StepIcon state={step.state}/></span>
        <b>{step.label}</b>
        <small>{step.state}</small>
      </li>)}
    </ol>
  </div>
}
